var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadCrumbs),function(crumbs){return _c('el-breadcrumb-item',{attrs:{"to":{ path: crumbs.path }}},[_vm._v(_vm._s(crumbs.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }